module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BAMSide",
    attrs: {
      "id": "BAMRippleWrap"
    }
  }, [_c('div', {
    staticClass: "BAMheader"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userInfo.avatar ? _vm.userInfo.avatar : _vm.defaultAvatar,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "userName"
  }, [_vm._v(_vm._s(_vm.userInfo.showName))]), _vm._v(" "), _c('p', {
    staticClass: "introduce",
    domProps: {
      "innerHTML": _vm._s(_vm.userInfo.singName)
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "navList"
  }, [_c('li', {
    staticClass: "ripple",
    on: {
      "click": _vm.toSelfPage
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("我的主页")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    on: {
      "click": _vm.toSelfCodePage
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("代码片段")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BAllBlog'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BAllBlog')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("我的文章")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BWriteBlog'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BWriteBlog')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("发布文章")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BDraft'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BDraft')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("草稿箱")])]), _vm._v(" "), _c('li', {
    staticClass: "ripple",
    class: {
      active: _vm.activeItem === 'BSelf'
    },
    on: {
      "click": function($event) {
        return _vm.changeItem('BSelf')
      }
    }
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("个人资料")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a087fc2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BAM/side/side.vue
// module id = 256
// module chunks = 1